import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../SvgIcon";

const ITEMS = [
  {
    key: "addAbove",
    modal: "add-exercise",
    position: "above",
    icon: "/img/new-icons/insert-add-above.svg",
  },
  {
    key: "addBelow",
    modal: "add-exercise",
    position: "below",
    icon: "/img/new-icons/insert-add-below.svg",
  },
  {
    key: "importAbove",
    modal: "import-workout",
    position: "above",
    icon: "/img/new-icons/insert-import-above.svg",
  },
  {
    key: "importBelow",
    modal: "import-workout",
    position: "below",
    icon: "/img/new-icons/insert-import-below.svg",
  },
];

/**
 * The "Insert" group of an exercise ••• menu: add an exercise / import a saved
 * workout directly above or below the exercise. Surface-agnostic — it only
 * needs the exercise and its week/session, and opens the existing Add Exercise
 * / Import Workout modals pre-targeted via `insertTarget` + `insertPosition`.
 * Render it as the first children of the menu's <ul role="listbox">.
 *
 * @param {object} props
 * @param {object} props.activeExercise the exercise (or grouped complex) the menu belongs to
 * @param {number|string} [props.week] program week of that exercise's session
 * @param {number|string} [props.session] program session (workout) number
 * @param {string} [props.day] calendar day (YYYY-MM-DD); set instead of week/session on the calendar
 * @param {Function} [props.onSelect] called when an item is picked (close the menu)
 */
const ExerciseInsertMenuItems = ({
  activeExercise,
  week,
  session,
  day,
  onSelect,
}) => {
  const { t } = useTranslation("athlete-portal");
  // A complex is one atomic row; any member anchors it.
  const insertTarget = activeExercise.exercises?.[0]?._id ?? activeExercise._id;

  const open = (item) => {
    onSelect?.();
    // The calendar registers its Add Exercise modal under its own key and
    // targets a day instead of a program week/session.
    const modal =
      day && item.modal === "add-exercise"
        ? "calendar-add-exercise"
        : item.modal;
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": modal,
        ...(day ? { day } : { programWeek: week, programSession: session }),
        ...(item.modal === "add-exercise" ? { editMode: false } : {}),
        insertTarget,
        insertPosition: item.position,
      },
    });
  };

  return (
    <>
      <li role="presentation" className="insert-menu-label">
        {t("programs.insert.group")}
      </li>
      {ITEMS.map((item) => (
        <li
          key={item.key}
          onClick={(e) => {
            e.stopPropagation();
            open(item);
          }}
        >
          <a className="insert-menu-item">
            <SvgIcon src={item.icon} useCurrentColor />
            {t(`programs.insert.${item.key}`)}
          </a>
        </li>
      ))}
      <li role="separator" className="exercise-menu-sep" />
    </>
  );
};

export default ExerciseInsertMenuItems;
